import { NodeAlignment } from "src/tiptap/components/tiptap-extension/node-alignment-extension"
import { TableHandleExtension } from "src/tiptap/components/tiptap-node/table-node/extensions/table-handle"
import { TableKit } from "src/tiptap/components/tiptap-node/table-node/extensions/table-node-extension"

export const createTableExtensions = () => [
  TableKit.configure({
    table: {
      resizable: true,
      allowTableNodeSelection: true,
      HTMLAttributes: {
        class: "formly-tiptap-table",
      },
    },
    tableCell: {
      HTMLAttributes: {
        class: "formly-tiptap-table-cell",
      },
    },
    tableHeader: {
      HTMLAttributes: {
        class: "formly-tiptap-table-header",
      },
    },
    tableRow: {
      HTMLAttributes: {
        class: "formly-tiptap-table-row",
      },
    },
  }),
  TableHandleExtension,
  NodeAlignment.configure({
    types: ["tableCell", "tableHeader"],
  }),
]

export default createTableExtensions
